// extracted by mini-css-extract-plugin
module.exports = {"controlButtons":"PhoneInputsForm_controlButtons__1VinJ","container":"PhoneInputsForm_container__20kLZ"};